import { render } from "./TranslationImportView.vue?vue&type=template&id=1a71c262&scoped=true&ts=true"
import script from "./TranslationImportView.vue?vue&type=script&lang=ts"
export * from "./TranslationImportView.vue?vue&type=script&lang=ts"

import "./TranslationImportView.vue?vue&type=style&index=0&id=1a71c262&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a71c262"]])

export default __exports__